import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const GroupHeaderStyled = styled(Stack)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  cursor: 'pointer',
  backgroundColor: theme.palette.gray[50],
  borderBottom: `1px solid ${theme.palette.divider}`,
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.black[850],
  }),
}));
